<template>
  <div id="main-app" class="container">
    <section class="header">
      <div class="header-controls">
        <a
          class="button is-danger"
          target="donate"
          href="https://www.patreon.com/ArtemAnufrij"
        >patreon</a>
        <a
          class="button is-warning"
          target="donate"
          href="https://liberapay.com/Artem/donate"
        >libera pay</a>
        <a class="button is-info" target="donate" href="https://www.paypal.me/ArtemAnufrij">pay pal</a>
      </div>
      <div class="header-body">
        <div class="header-body-content">
          <img src="static/LOGO.svg">
          <h1 class="title">Artem Anufrij</h1>
          <h2 class="subtitle">Open Source Developer</h2>
          <font-icon id="icon-down" icon="angle-down"/>
        </div>
      </div>
    </section>
    <section>
      <h2 class="subtitle is-2 app-cluster">Native Apps for Linux</h2>
      <div class="columns is-multiline">
        <AppPreview v-for="(app, i) in apps_native" :app="app" :key="i" @clicked="showDetails"/>
      </div>
      <h2 class="subtitle is-2 app-cluster">Electron Apps for Linux</h2>
      <div class="columns is-multiline">
        <AppPreview v-for="(app, i) in apps_electron" :app="app" :key="i" @clicked="showDetails"/>
      </div>
    </section>
    <section class="footer">
      <a target="github" href="https://github.com/artemanufrij" title="Artem Anufrij on Gtihub">
        <font-icon :icon="['fab', 'github']" size="3x"/>
      </a>
      <a target="gitlab" href="https://gitlab.com/artemanufrij" title="Artem Anufrij on Gitlab">
        <font-icon :icon="['fab', 'gitlab']" size="3x"/>
      </a>
      <a
        target="google"
        href="https://plus.google.com/+ArtemAnufrij"
        title="Artem Anufrij on Google Plus"
      >
        <font-icon :icon="['fab', 'google-plus']" size="3x"/>
      </a>
    </section>
    <AppDetail ref="AppDetail" @closed="closedDetails" @opened="openedDetails"/>
  </div>
</template>

<script>
import AppPreview from "@/components/AppPreview";
import AppDetail from "@/components/AppDetail";
import Translit from "../app/translit/src/App";
export default {
  data() {
    return {
      apps_electron: [],
      apps_native: []
    };
  },
  created() {
    this.$http.get("static/apps_electron.json").then(response => {
      this.apps_electron = response.data;
      this.selectElectronApp();
    });
    this.$http.get("static/apps_native.json").then(response => {
      this.apps_native = response.data;
      this.selectNativeApp();
    });
    window.addEventListener("keydown", this.appKeyDown);
  },
  methods: {
    selectElectronApp() {
      this.apps_electron.forEach(app => {
        if (app.title.replace(" ", "_") == this.$route.params.app) {
          this.showDetails(app);
          return;
        }
      });
    },
    selectNativeApp() {
      this.apps_native.forEach(app => {
        if (app.title.replace(" ", "_") == this.$route.params.app) {
          this.showDetails(app);
          return;
        }
      });
    },
    showDetails(app) {
      this.$refs.AppDetail.show(app);
    },
    closedDetails() {
      this.$router.push({ path: "/" });
    },
    openedDetails(app) {
      this.$router.push({ path: "/" + app.title.replace(" ", "_") });
    },
    appKeyDown(event) {
      if (this.$refs.AppDetail != null && event.key == "Escape") {
        this.$refs.AppDetail.close();
      }
    }
  },
  components: {
    AppPreview,
    AppDetail,
    Translit
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue